<div class="">
  <div class="custom-table-heading-container">
    <mat-icon class="icon-bottom">add_shopping_cart</mat-icon>
    {{'PRICING.ADDITIONAL_SERVICES.ADDITIONAL_SERVICES' | transloco}}
  </div>
  <div class="overflow-auto">
    <table mat-table class="custom-table"
      [dataSource]="additionalServices().length > 0 ? dataSource : emptyData" matSort>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{element.name | translateAttribute}}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.DESCRIPTION' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{element.description | translateAttribute}}</td>
      </ng-container>

      <ng-container matColumnDef="performingOrganizationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.PERFORMING_ORGANIZATION_NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{element.performingOrganizationName}}</td>
      </ng-container>

      <ng-container matColumnDef="productCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.PRODUCT' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{element.productCode}}</td>
      </ng-container>

      <ng-container matColumnDef="availability">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.AVAILABILITY' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{element.availability}}</td>
      </ng-container>

      <ng-container matColumnDef="minimumStay">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.MINIMUM_STAY' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{element.minimumStay}}</td>
      </ng-container>

      <ng-container matColumnDef="typeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.TYPE' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
          @if (element.typeName === 'MandatoryForAllAdditionalServices') {
            {{ 'PRICING.ADDITIONAL_SERVICES.MANDATORY' | transloco }}
          } @else {
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="totalPrice">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.TOTAL_PRICE' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{element.totalPrice}}</td>
      </ng-container>

      <ng-container matColumnDef="statusName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.ADDITIONAL_SERVICES.STATUS' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
          @if (element.statusName) {
            <app-status-badge [color]="getStatusColor(element.statusName)"
            [text]="element.statusName"></app-status-badge>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="empty-row">
        <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsAdditionalServices"></tr>
      <tr mat-row
        *matRowDef="let row; columns: additionalServices().length > 0 ? displayedColumnsAdditionalServices : ['empty-row'];"
        (click)="openEditAdditionalServiceModal(row)" class="clickable">
      </tr>
    </table>
  </div>
</div>
